import { Component, DestroyRef, HostBinding, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable, map } from 'rxjs';
import { BreadcrumbTrail, BreadcrumbsService } from '../services/breadcrumbs.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class BreadcrumbsComponent {
  public readonly trail$: Observable<BreadcrumbTrail>;
  public readonly shouldShow$: Observable<boolean>;

  /** Complete SEO trails sit above the page host (which stacks at z-index 9) so they stay visible. */
  @HostBinding('class.seo-trail')
  public completeTrail = false;

  public constructor(private readonly breadcrumbsService: BreadcrumbsService) {
    this.trail$ = this.breadcrumbsService.trail$;
    this.trail$.pipe(takeUntilDestroyed(inject(DestroyRef))).subscribe((trail) => {
      this.completeTrail = trail.complete && trail.items.length > 0;
    });
    // Only show breadcrumbs when there are actual breadcrumb items (not on home page)
    this.shouldShow$ = this.trail$.pipe(
      map(trail => trail.items.length > 0)
    );
  }
}
